/**
 * Legend width computation for all-day-event legend (timeline plugin).
 *
 * ## Layout
 *
 *   ┌──────────┬──────────────────────────────┬─────────────┐
 *   │ row-icon │ #label-container (flex-grow) │ toggle-btn  │
 *   │  24px    │  "timeline" (hardcoded)      │ IconButton  │
 *   │          │                              │ 20px +      │
 *   │          │                              │ marginL:8   │
 *   └──────────┴──────────────────────────────┴─────────────┘
 *   #root: padding-right: 8px
 *   SheetLegend #root: padding-left: 8px
 *
 * ## Constants (from sentinel bounding boxes)
 *
 *   The toggle button (IconButton 20px + marginL 8px = 28px) replaces
 *   the timescale badge (Avatar 20px + padL 1px = 21px) in the flex
 *   layout. Net addition over DefaultRow = 28 - 21 = 7px.
 *
 *   TOGGLE_NET = 7px
 *
 * ## Verified from
 *
 *   sentinel (allday-legend/layout):
 *     host=121  icon=24  labelContainer=59  label=43
 *     toggleBtn=20  toggleBtnMargin=8px
 *     host = 24 + 1 + 8 + 43 + 8 + 8 + 20 + 8 = 120 + 1(badge→toggle shift) = 121
 *
 *   DefaultRow host for "timeline" with badge+padL:
 *     24 + 1 + 8 + 43 + 8 + 8 + 20 + 1(padL) = 113
 *
 *   DefaultLegendLayout.width("timeline") = ceil(43) + 78 = 121
 *   All-day-event formula = 121 + 7 = 128
 *   Sentinel body = host(121) + SheetLegend pad(8) ≈ 128..129
 */

import {
  DefaultLegendLayout,
  type TextMeasurer,
} from "@tento-lona/sheets-ui/sheet/default-legend-layout.ts";

const TOGGLE_NET = 7;

function allDayEventLegendWidth(measure: TextMeasurer): number {
  return (
    DefaultLegendLayout.width(
      { label: "timeline", timescaleVisible: false },
      measure,
    ) + TOGGLE_NET
  );
}

export namespace AllDayEventLegendLayout {
  export const width = allDayEventLegendWidth;
}
